export default function Inventario() {
  return <h2>Inventario</h2>;
}
